var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup421(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H69V24H0z",
    className: "cls-1"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-5{fill:none}.cls-2{fill:#f4f7f2}.cls-3{fill:#486a41}.cls-5{stroke:#486a41;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    transform: "translate(-1407 -507)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    cx: 90.5,
    cy: 90.5,
    r: 90.5,
    className: "cls-2",
    transform: "translate(1515 567)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_101",
    cx: 45,
    cy: 44.5,
    className: "cls-2",
    rx: 45,
    ry: 44.5,
    transform: "translate(1419 596)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_004-scanning",
    transform: "translate(1535.125 619.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    d: "M230.469 123.132h-58.928a1.922 1.922 0 0 0 0 3.843h58.928a1.922 1.922 0 0 0 0-3.843z",
    className: "cls-3",
    transform: "translate(-131.187 -107.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    d: "M207.616 123.43l-3.5-21.031a1.922 1.922 0 1 0-3.791.632l3.518 21.106c.008.051.019.1.031.15l2.737 10.946a5.765 5.765 0 0 1-5.593 7.163h-21.813l-6.326-42.17L172.1 95h30.5a9.608 9.608 0 0 0 9.584-10.292l-1.464-20.5a9.642 9.642 0 0 0-9.583-8.923h-74.829a1.922 1.922 0 0 0-1.917 2.058l2.562 35.87A1.922 1.922 0 0 0 128.87 95h26.487l2.352 18.814a1.922 1.922 0 0 0 1.907 1.683h11.668l4.366 29.103a1.922 1.922 0 0 0 1.9 1.636h23.463a9.608 9.608 0 0 0 9.321-11.938zm-46.3-11.778L159.23 95h8.937l2.082 16.654zm-30.653-20.5l-2.287-32.026h72.767a5.785 5.785 0 0 1 5.75 5.354l1.464 20.5a5.765 5.765 0 0 1-5.75 6.175h-71.948z",
    className: "cls-3",
    transform: "translate(-96.203 -55.286)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    d: "M19.856 91.154a16.013 16.013 0 0 1 0-32.026 1.922 1.922 0 1 0 0-3.843 19.856 19.856 0 0 0 0 39.712 1.921 1.921 0 1 0 0-3.843z",
    className: "cls-3",
    transform: "translate(0 -55.284)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    d: "M54.839 104.359a1.922 1.922 0 0 0 0-3.843 9.608 9.608 0 1 0 0 19.216 1.922 1.922 0 1 0 0-3.843 5.765 5.765 0 1 1 0-11.53z",
    className: "cls-3",
    transform: "translate(-34.983 -90.267)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_4",
    clipPath: "url(#clip-path)",
    transform: "translate(1430 629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    transform: "translate(-723 -314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_615",
    d: "M0 0H9V44H0z",
    className: "cls-3",
    transform: "translate(723 314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_616",
    d: "M0 0H6V44H0z",
    className: "cls-3",
    transform: "translate(737 314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_617",
    d: "M0 0H3V44H0z",
    className: "cls-3",
    transform: "translate(748 314)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_350-2",
    transform: "translate(-690 -314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_615-2",
    d: "M0 0H9V44H0z",
    className: "cls-3",
    transform: "translate(723 314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_616-2",
    d: "M0 0H6V44H0z",
    className: "cls-3",
    transform: "translate(737 314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_617-2",
    d: "M0 0H3V44H0z",
    className: "cls-3",
    transform: "translate(748 314)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_350-3",
    transform: "translate(-657 -314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_615-3",
    d: "M0 0H9V44H0z",
    className: "cls-3",
    transform: "translate(723 314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_616-3",
    d: "M0 0H6V44H0z",
    className: "cls-3",
    transform: "translate(737 314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_617-3",
    d: "M0 0H3V44H0z",
    className: "cls-3",
    transform: "translate(748 314)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    d: "M169 4107.455v-11.886h10.711",
    className: "cls-5",
    transform: "translate(1250 -3478.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    d: "M169 4095.568v11.887h10.711",
    className: "cls-5",
    transform: "translate(1250 -3442.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    d: "M179.711 4107.455v-11.886H169",
    className: "cls-5",
    transform: "translate(1329.066 -3478.883)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    d: "M179.711 4095.568v11.887H169",
    className: "cls-5",
    transform: "translate(1329.066 -3442.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_663",
    d: "M0 0H300V300H0z",
    className: "cls-1",
    transform: "translate(1407 507)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup421);
export default __webpack_public_path__ + "static/media/Group 421.f26c879c3198554c79724801fe7d7c70.svg";
export { ForwardRef as ReactComponent };